<!--
 * @Author: zouyuping
 * @version: 
 * @Date: 2022-04-18 15:48:13
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-10-26 11:14:36
 * @FilePath: 
 * @Description: 挂号订单确认页
-->
<template>
  <div class="p-t-1">
    <div class="info_card_box">
      <div class="f-bt order_user_item">
        <p class="order_title_con">
          <img src="@/assets/tab_image/mine.svg" alt="" />

          预约人
        </p>
        <p class="c-grey-6">{{ bookOrderInfo.PersonName }}</p>
      </div>
      <div class="f-bt order_user_item">
        <p class="order_title_con">
          <img src="@/assets/svg/phone.svg" alt="" />手机号
        </p>
        <p class="c-grey-6">{{ bookOrderInfo.MemberPhone }}</p>
      </div>
      <div class="f-bt order_user_item">
        <p class="order_title_con">
          <img src="@/assets/svg/member-card.svg" alt="" />会员卡
        </p>
        <p @click="handleSelectCard" class="card_con">
          <i class="c-theme">{{ bookOrderInfo.CardTypeName }}</i>
          <i class="iconfont icon-xiangyou c-grey-6" />
        </p>
      </div>
    </div>
    <div class="info_card_box info_card_box2">
      <div class="info_card_title">预约信息</div>
      <div class="f-bt book_info_item">
        <span class="info_title_con">预约项目</span>
        <span>{{ bookOrderInfo.ProjectName }}</span>
      </div>
      <div class="f-bt book_info_item" v-if="showJIshi">
        <span class="info_title_con">预约诊疗师</span>
        <span>{{ bookOrderInfo.JishiName }}</span>
      </div>
      <div class="f-bt book_info_item">
        <span class="info_title_con">预约时间</span>
        <span>{{ bookOrderInfo.PeriodTime }}</span>
      </div>
      <div class="f-bt book_info_item" v-if="isNeedCheckNumber">
        <span class="info_title_con">预约人数</span>
        <span>{{ bookOrderInfo.NumberOfPeople }}</span>
      </div>
    </div>
    <div class="info_card_box info_card_box2" v-if="Remindertips">
      <div class="info_card_title">温馨提示</div>
      <div>{{ Remindertips }}</div>
    </div>
    <div class="footer">
      <van-button
        color="var(--tc)"
        round
        block
        @click="handleSubmitOrder"
        :loading="isSubmitLoading"
        loading-text="提交中..."
        >确定</van-button
      >
      <!-- <p class="dark-btn" @click="placeOrder"
      v-if="keyBindMode !== 'ManualInputByWaiter' || handCode">{{ wechatPointPayMode === 'CyBillWithPad' ? '呼叫服务员' : '提交订单' }}</p> -->
    </div>
    <van-popup v-model="showCardPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="cardTypeColumns"
        :value-key="'CardTypeName'"
        @confirm="onConfirm"
        @cancel="showCardPicker = false"
      />
    </van-popup>
  </div>
</template>

<script>
import { submitBookRegister } from "@/api/bookRegister";
import { handleLocalStorage, handleTimeLocalStorage } from "@/utils";
export default {
  name: "BookRegisterOrderInfo",
  props: {},
  data() {
    return {
      bookOrderInfo: {
        PersonName: "",
        MemberPhone: "",
        CardType: "",
        CardTypeName: "",
        ProjectName: "",
        JishiName: "",
        PeriodTime: "",
        NumberOfPeople: 1,
      },
      isSubmitLoading: false,
      showCardPicker: false,
      cardTypeColumns: [],
      Remindertips: "",
      showJIshi: false,
      isNeedCheckNumber: false,
    };
  },
  components: {},
  created() {},
  mounted() {
    const membetInfo = handleLocalStorage.get("memberInfo");

    this.bookOrderInfo.PersonName = membetInfo.MemberName;
    this.bookOrderInfo.MemberPhone = membetInfo.MobilePhone;

    const pointProject = handleTimeLocalStorage.get("pointProject");
    this.bookOrderInfo.ProjectName = pointProject.Name;
    this.bookOrderInfo.JishiName = pointProject.JishiName;

    this.bookOrderInfo.PeriodTime =
      pointProject.yearDate + " " + pointProject.curPeriodName;
    this.bookOrderInfo.NumberOfPeople = pointProject.NumberOfPeople;
    this.getCardList();
    const bookConfigData = handleTimeLocalStorage.get("bookConfig");
    this.Remindertips = bookConfigData.Reminder;
    this.showJIshi = bookConfigData.JsStatusId == 1;
    this.isNeedCheckNumber = bookConfigData.BookingNumberOfPeople == 1;
  },
  methods: {
    getCardList() {
      const params = {
        IsBindWx: true,
        VpnId: this.$store.state.vpnId,
      };
      $http("wechath5/zh-cn/v1/member/list", params, "get").then((res) => {
        const cardArr = [];
        res.forEach((item) => {
          cardArr.push({ CardTypeName: item.CardTypeName, Id: item.Id });
        });
        this.cardTypeColumns = cardArr;
        this.bookOrderInfo.CardType = cardArr[0] ? cardArr[0].Id : "";
        this.bookOrderInfo.CardTypeName = cardArr[0]
          ? cardArr[0].CardTypeName
          : "";
      });
    },
    handleSelectCard() {
      this.showCardPicker = true;
    },
    onConfirm(value, index) {
      this.bookOrderInfo.CardType = this.cardTypeColumns[index].Id;
      this.bookOrderInfo.CardTypeName =
        this.cardTypeColumns[index].CardTypeName;

      this.showCardPicker = false;
    },
    handleSubmitOrder() {
      //   const _this = this;
      if (!this.bookOrderInfo.CardType) {
        return this.$toast("请选择会员卡！");
      }
      const pointProjectInfo = handleTimeLocalStorage.get("pointProject");
      const requestData = {
        VpnId: this.$store.state.vpnId,
        AccountId: this.bookOrderInfo.CardType,
        GoodsId: pointProjectInfo.Id,
        JiShiId: pointProjectInfo.JishiId,
        TimeSpanId: pointProjectInfo.curPeriodIndex,
        Date: pointProjectInfo.yearDate,
        NumberOfPeople: pointProjectInfo.NumberOfPeople,
      };
      this.isSubmitLoading = true;
      submitBookRegister(requestData)
        .then((res) => {
          this.isSubmitLoading = false;
          this.$router.replace({
            name: "BookRegisterResult",
            query: { BookId: res },
          });
        })
        .catch(() => {
          this.isSubmitLoading = false;
        });
    },
  },
};
</script>
<style scoped lang="scss">
.info_card_box {
  background: #fff;
  padding: 0 32px;
  border-radius: 10px;
  margin: 20px;
  &.info_card_box2 {
    padding: 1px 20px 15px;
  }
  .order_user_item {
    line-height: 100px;
    border-bottom: 1px solid #dedede;

    &:last-child {
      border-bottom: none;
    }
    .order_title_con {
      img {
        width: 42px;
        height: 42px;
        margin-right: 16px;
        vertical-align: -9px;
      }
    }
  }
  .book_info_item {
    line-height: 72px;
  }
  .info_title_con {
    color: #333;
  }
  .info_card_title {
    font-weight: bold;
    padding: 32px 0 22px;
    color: #333;
    font-size: 30px;
  }
  .card_con {
    i {
      font-size: 28px;
    }
  }
}
.footer {
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 2;
  width: 100%;
  height: 140px;
  border-top: 1px solid #eee;
  background: #fff;
  box-sizing: border-box;
  padding: 0 32px;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
}
</style>
